import { IconProps } from "@lib/types/General";

export default function SendByte(props: IconProps) {
  const { width = "1em", height = "1em" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 500 500"
      width={width}
      height={height}
      fill="currentColor"
      stroke="currentColor"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        className="st0"
        d="M378.8,247.54c13.44-8.93,23.25-23.57,28.21-42.47,5.27-20.1,4.76-44.08-1.36-64.16-12.65-41.43-57.47-62.58-96.36-65.2V18.71h-50.45v56.95h-18.72V18.71h-50.45v56.95h-28.98c-13.1,0-35.41,10.68-44.42,17.75-30.5,23.92-35.36,68-26.97,98.83,12.17,44.72,60.08,59.77,106.4,74.33,34.09,10.72,36.29,20.83,52.43,41.52,7.81,10,12.5,31.53,6.84,42.39-2.96,5.65-9.33,9.94-15.94,10.77h-70.05c-18.07-3.42-27.98-21.55-28.43-37.87l-.07-2.52-5.17-6.44h-60.63l.08,7.58c.4,36.57,21.17,73.42,51.68,91.69,4.98,2.98,22.56,11.64,32.25,11.64h31.4v55.95h50.54v-55.95h20.94l.04,55.95h50.23v-55.76l5.48-.21c7.16-.27,14.95-.76,23.05-2,8.1-1.24,16.5-3.22,24.86-6.46,36.3-14.1,59.85-48.76,60.01-88.31.13-34.69-17.36-64.71-46.44-81.01ZM154.25,186.12c-5.81-7.9-6.68-22.45-1.99-33.11,2.25-5.1,6.64-11.34,14.85-12.4h78.94c12.7,7.37,17.03,23.4,16.8,36.28-.31,17.63-8.39,32.62-20.57,38.2-7.02,3.22-27.8,5.91-27.8,5.91,0,0-4.9-.5-13.53-2.71-27.59-7.08-35.38-16.77-46.7-32.17Z"
      />
    </svg>
  );
}
